import TextInput from "../TextInput/TextInput";
import ImageInput from "../ImageInput/ImageInput";
import uploadPlaceholder from "../../assets/upload-file.svg";
import {useState} from "react";
import TextEditor from "../TextEditor/TextEditor";
import { baseImagesUrl} from "../../assets/Constants";

const CategoryForm = ({category, onChange}) => {
    const [categoryForm, setCategoryForm] = useState(category);
    const changeCategory = (key, value) => {
        const newCategory = {...categoryForm, [key]: value};
        setCategoryForm(newCategory);
        onChange(newCategory);
    }
    return (
        <div className="row">
            <div className="col-md-6">
                <TextInput label={"نام (به فارسی)"} value={categoryForm.persianName}
                           onChange={(value) => {
                               changeCategory("persianName", value);
                           }}/>
            </div>
            <div className="col-md-6">
                <TextInput label={"نام (به انگلیسی)"} value={categoryForm.englishName}
                           onChange={(value) => {
                               changeCategory("englishName", value);
                           }}/>
            </div>
            <div className="col-12">
                <div className="card">
                    <div className="card-body">
                        <label className="card-title mb-2">آپلود لوگو</label>
                        <div className="row">
                            {
                                categoryForm.logos.map((logo, index) => {
                                    return (<div key={index} className="col-md-2">
                                        <img
                                            className={`w-100 productImage ${logo == categoryForm.activeLogo ? "border border-2 border-success" : ""}`}
                                            src={logo.includes("logo_") ? `${baseImagesUrl}category/${logo}` : logo}
                                            onDoubleClick={() => {
                                                changeCategory("activeLogo", logo)
                                            }}
                                        />
                                        <button className={"btn btn-danger w-100"} onClick={() => {
                                            const newLogos = categoryForm.logos.filter((l) => {
                                                if (logo != l) {
                                                    return l;
                                                }
                                            });
                                            changeCategory("logos", newLogos);
                                            if (categoryForm.activeLogo == logo)
                                                changeCategory("activeLogo", "");

                                        }}>حذف
                                        </button>

                                    </div>)
                                })
                            }
                            <div className="col-md-2">
                                <ImageInput defaultPic={uploadPlaceholder} onChange={(value) => {
                                    const newLogos = [...categoryForm.logos, value];
                                    changeCategory("logos", newLogos)
                                }}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12">
                <div className="card">
                    <div className="card-body">
                        <label className="card-title mb-2">آپلود آواتار</label>
                        <div className="row">
                            {
                                categoryForm.avatars.map((avatar, index) => {
                                    return (<div key={index} className="col-md-2">
                                        <img
                                            className={`w-100 productImage ${avatar == categoryForm.activeAvatar ? "border border-2 border-success" : ""}`}
                                            src={avatar.includes("avatar_") ? `${baseImagesUrl}category/${avatar}` : avatar}
                                            onDoubleClick={() => {
                                                changeCategory("activeAvatar", avatar)
                                            }}
                                        />
                                        <button className={"btn btn-danger w-100"} onClick={() => {
                                            const newAvatars = categoryForm.avatars.filter((a) => {
                                                if (avatar != a) {
                                                    return a;
                                                }
                                            });
                                            changeCategory("avatars", newAvatars);
                                            if (categoryForm.activeAvatar == avatar)
                                                changeCategory("activeAvatar", "");

                                        }}>حذف
                                        </button>

                                    </div>)
                                })
                            }
                            <div className="col-md-2">
                                <ImageInput aspect={5 / 3} defaultPic={uploadPlaceholder} onChange={(value) => {
                                    const newAvatars = [...categoryForm.avatars, value];
                                    changeCategory("avatars", newAvatars)
                                }}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12">
                <TextEditor label={"تاریخچه"} value={categoryForm.summary} onChange={(value) => {
                    changeCategory("summary", value)
                }} />
            </div>
        </div>
    )
}

export default CategoryForm;